import { render, staticRenderFns } from "./CategoryGroupIncidenceSelects.vue?vue&type=template&id=72a70bea&scoped=true"
import script from "./CategoryGroupIncidenceSelects.vue?vue&type=script&lang=js"
export * from "./CategoryGroupIncidenceSelects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a70bea",
  null
  
)

export default component.exports